import { NgModule } from '@angular/core';
import { CoreModule, StorageService, I18nHttpLoaderFactory } from '@fs/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { StorageModule } from '@fs/core';
import { TheprojectSharedModule, TheprojectBasicModule } from '@fs/theproject';
@NgModule({
  declarations: [
  ],
  imports: [
    StorageModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: I18nHttpLoaderFactory,
        deps: [HttpClient, StorageService]
      },
      isolate: true
    }),
    //@fs/core
    CoreModule.forRoot(),
    //themes-theproject
    TheprojectSharedModule.forRoot(),
    TheprojectBasicModule.forRoot()
    //modules
  ],
  exports: [
    
  ]
})
export class AppCoreModule {}
